import React, {useRef, useEffect} from "react";
import videojs from "video.js";
// import "../../assets/videojs-plus/plugins/eme/index";
// import "../../assets/videojs-plus/plugins/quality/index";

import {getAccessToken} from "../../services/api-client";
import {Client} from '../../services/api-client';

const defaultPlayerOptions = {
    autoplay: true,
    muted: true,
    aspectRatio: "16:9",
    mobileView: false
};
const b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

export enum PPApiResponseType {
    ARRAY_BUFFER = 'arraybuffer',
    BLOB = 'blob',
    JSON = 'json',
    TEXT = 'text',
}

export enum PPApiTokenType {
    BEARER = 'Bearer',
    BASIC = 'Basic',
}

export enum PPApiTokenStorageType {
    LOCAL_STORAGE = 'localstorage',
    COOKIE = 'cookie',
}

export interface PPApiConfig {
    baseUrl: string;
    tokenKey?: string;
    tokenType?: PPApiTokenType;
    storedIn?: PPApiTokenStorageType;
    headers?: PPApiHeaders;
}

export interface PPApiOptions {
    apiPath: string;
    params?: PPApiParams;
    headers?: PPApiHeaders;
    responseType?: PPApiResponseType;
    withCredentials?: boolean;
    config?: PPApiConfig;
}

export class PPApiParams {
}

export class PPApiHeaders {
}

export interface PPApiMethodOptions {
    headers?: PPApiHeaders;
    observe?: 'body' | 'events' | 'response';
    params?: PPApiParams;
    reportProgress?: boolean;
    responseType?: any;
    withCredentials?: boolean;
}

export interface PPApiConfig {
    baseUrl: string;
    tokenKey?: string;
    tokenType?: PPApiTokenType;
    storedIn?: PPApiTokenStorageType;
    headers?: PPApiHeaders;
}

export interface PPApiOptions {
    apiPath: string;
    params?: PPApiParams;
    headers?: PPApiHeaders;
    responseType?: PPApiResponseType;
    withCredentials?: boolean;
    config?: PPApiConfig;
}

const hexToBase64 = (str: any) => {
    return btoa(
        String.fromCharCode.apply(
            null,
            str
                .replace(/\r|\n/g, '')
                .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
                .replace(/ +$/, '')
                .split(' ')
        )
    )
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=*$/, '');
}
const keyCharAt = (key: string, i: number) => {
    return key.charCodeAt(Math.floor(i % key.length));
}
const b64_decode = (data: any) => {
    let o1,
        o2,
        o3,
        h1,
        h2,
        h3,
        h4,
        bits,
        i = 0,
        result = [];
    if (!data) {
        return data;
    }
    data += '';
    do {
        h1 = b64.indexOf(data.charAt(i++));
        h2 = b64.indexOf(data.charAt(i++));
        h3 = b64.indexOf(data.charAt(i++));
        h4 = b64.indexOf(data.charAt(i++));
        bits = (h1 << 18) | (h2 << 12) | (h3 << 6) | h4;
        o1 = (bits >> 16) & 0xff;
        o2 = (bits >> 8) & 0xff;
        o3 = bits & 0xff;
        result.push(o1);
        if (h3 !== 64) {
            result.push(o2);
            if (h4 !== 64) {
                result.push(o3);
            }
        }
    } while (i < data.length);
    return result;
}
const decrypt = (key: string, data: string | number[]) => {
    data = b64_decode(data);
    return xor_decrypt(key, data);
}
const xor_encrypt = (key: any, data: any) => {
    return Object.assign([], data).map((c: string, i: any) => {
        return c.charCodeAt(0) ^ keyCharAt(key, i);
    });
}

const getAwsKey = (url: string) => {
    const path = 'v1' + `/files/get-signed-cookie`;
    const options: PPApiOptions = {
        apiPath: path,
    };
    return fetch('');
}
const encrypt = (key: any, data: any) => {
    data = xor_encrypt(key, data);
    return b64_encode(data);
}
const b64_encode = (data: any) => {
    let o1,
        o2,
        o3,
        h1,
        h2,
        h3,
        h4,
        bits,
        r,
        i = 0,
        enc = '';
    if (!data) {
        return data;
    }
    do {
        o1 = data[i++];
        o2 = data[i++];
        o3 = data[i++];
        bits = (o1 << 16) | (o2 << 8) | o3;
        h1 = (bits >> 18) & 0x3f;
        h2 = (bits >> 12) & 0x3f;
        h3 = (bits >> 6) & 0x3f;
        h4 = bits & 0x3f;
        enc +=
            b64.charAt(h1) +
            b64.charAt(h2) +
            b64.charAt(h3) +
            b64.charAt(h4);
    } while (i < data.length);
    r = data.length % 3;
    return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
}
const xor_decrypt = (key: any, data: any) => {
    return Object.assign([], data)
        .map((c: number, i: any) => {
            return String.fromCharCode(c ^ keyCharAt(key, i));
        })
        .join('');
}
const base64ToHex = (str: string) => {
    str = str.replace(/\-/g, '+').replace(/\_/g, '/');
    for (
        var i = 0, bin = atob(str.replace(/[ \r\n]+$/, '')), hex = [];
        i < bin.length;
        ++i
    ) {
        let tmp = bin.charCodeAt(i).toString(16);
        if (tmp.length === 1) {
            tmp = '0' + tmp;
        }
        hex[hex.length] = tmp;
    }
    return hex.join('');
}
const GET_LICENCE =
    'v1' + `/videos/get-otp`
const getKeyFromServer = async (params: any) => {
    return Client.get(GET_LICENCE, {params: {key: params.key}});
}

function HLSPlayer({
                       children,
                       src,
                       onPlayerInit,
                       onPlayerDispose
                   }: any) {
    const containerRef = useRef(null as any);
    const getLicenseFromServer = async (emeOptions: any, keyMessage: any, callback: any) => {
        const request = JSON.parse(new TextDecoder().decode(keyMessage));
        const params = {
            key: encrypt(
                getAccessToken(),
                base64ToHex(request.kids[0])
            ),
        };
        try {
            const response: any = await getKeyFromServer(params);
            console.log(response);
            console.log('response --->');
            const keyObj = {
                kty: 'oct',
                kid: request.kids[0],
                k: hexToBase64(
                    decrypt(
                        getAccessToken(),
                        response['data'].otp
                    )
                ), // This key should be come from server
            };


            callback(
                null,
                new TextEncoder().encode(
                    JSON.stringify({
                        keys: [keyObj],
                    })
                )
            );
        } catch (e) {
        }
    }
    const qualities = ['1080p', '720p'];

    const playerOptions = {
        qualities: qualities.map((quality, index)=>{
            return  {
                sources: [{
                    src,
                    label: quality,
                    default: index === 1,
                    type: 'application/x-mpegURL',
                    keySystems: {
                        'org.w3.clearkey': {
                            videoContentType: 'video/mp4;codecs="avc1.42c01e"',
                            audioContentType: 'audio/mp4;codecs="mp4a.40.2"',
                            getLicense: (
                                emeOptions: any,
                                keyMessage: any,
                                callback: any
                            ) => {
                                console.log('get licence gets called')
                                console.log(emeOptions)
                                console.log(keyMessage)
                                getLicenseFromServer(emeOptions, keyMessage, callback);
                            },
                        },
                    },
                }],
                label: quality,
                default: index === 1,
            }
        })
    };
    useEffect(() => {
        try {
            if (containerRef.current) {
                const videoEl = containerRef.current.querySelector("video");
                const player: any = videojs(videoEl, {
                    ...defaultPlayerOptions,
                    ...playerOptions
                });

                player.eme();
                // used to move children component into player's element
                // your may not the script
                const playerEl = player.el();
                const flag = player.getChild("PlayToggleLayer").el();
                for (const child of containerRef.current.children) {
                    if (child !== playerEl) {
                        playerEl.insertBefore(child, flag);
                    }
                }
                // ----
                onPlayerInit && onPlayerInit(player);

                // for debug purpose
                // @ts-ignore
                window.player = player;

                return () => {
                    onPlayerDispose && onPlayerDispose(null);
                    player.dispose();
                };
            }
        } catch (e) {
            console.log(e)
        }
    }, [onPlayerInit, onPlayerDispose, playerOptions]);

    return (
        <div className="player" ref={containerRef}>
            <video/>
        </div>
    );
}

export default HLSPlayer;